import {ComponentBase} from './component-base';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import { Directive } from "@angular/core";

@Directive()
export class RouteComponentBase extends ComponentBase {
  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly location: Location,
    protected readonly router?: Router,
  ) {
    super(router);
  }

  getQueryParam(key: string) {
    return this.route.snapshot.queryParamMap.get(key);
  }

  getRouteParam(key: string) {
    return this.route.snapshot.paramMap.get(key);
  }

  goBack(): void {
    this.location.back();
  }
}
